/**
 * @fileoverview TransactionTypeReportPage - Transaction type and date range search page.
 *
 * Page for searching and reporting on transactions by transaction type within a date range.
 *
 * @description This page component:
 * - Allows filtering transactions by type (Expense, Income, Transfer, Adjustment)
 * - Supports date range filtering (inclusive)
 * - Shows summary statistics for the filtered results
 * - Displays filtered transaction list with sorting
 *
 * Component composition:
 * - BackButton: Return to main page
 * - TransactionTypeReport: Main report component with filters and results
 *
 * @module pages/TransactionTypeReportPage
 */
import TransactionTypeReport from '../components/Reports/TransactionTypeReport';
import BackButton from '../components/shared/BackButton';
import styles from './ReportPage.module.css';

/**
 * Transaction type search and report page.
 *
 * @param {Object} props - Component props
 * @param {Object} props.transactionHook - Transaction hook with all transaction data
 * @param {Object} props.categoryHook - Category hook for category information
 * @param {Object} props.budgetInfo - Budget metadata including start month
 * @param {Function} props.onBack - Navigate back handler
 */
function TransactionTypeReportPage({
  transactionHook,
  categoryHook,
  budgetInfo,
  onBack
}) {
  return (
    <div className={styles.container}>
      <BackButton onClick={onBack} />
      <h1 className={styles.pageTitle}>Transaction Type Search</h1>

      <TransactionTypeReport
        transactionHook={transactionHook}
        categoryHook={categoryHook}
        budgetInfo={budgetInfo}
      />
    </div>
  );
}

export default TransactionTypeReportPage;
